<template>
  <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />

    <div class="bg-red-50">
      {{ errors.load }}
    </div>

    <ErrorMessage
      v-if="errors.load"
      :error="errors.load"
      class="max-w-sm mx-auto"
    />


    <Loader v-if="loading" />

    <div v-else-if="data.course.id">
      <PageTitle v-bind:title="title" v-bind:admin="false" />

      <div class="py-16 my-16 overflow-hidden">
        <div class="max-w-7xl mx-auto px-4 space-y-8 sm:px-6 lg:px-8">
          <div class="my-4">
            <ErrorMessage
              v-if="errors.any"
              :error="errors.any"
              class="max-w-sm mx-auto"
            />
            <div
              v-if="data.canBeFinished"
              class="bg-green-50 px-4 py-2 my-4 text-green-700 border border-green-300 rounded-lg"
            >
              Все главы пройдены! Нажмите "Завершить Курс"!
            </div>
            <div
              v-if="data.status_id == 5"
              class="bg-green-50 px-4 py-2 my-4 text-green-700 border border-green-300 rounded-lg"
              role="alert"
            >
              Этот Курс вами пройден.
            </div>
          </div>
          <div class="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-start">
            <div class="relative z-10">
              <div class="prose mb-2 mx-auto lg:max-w-none">
                <h3>Информация о Курсе:</h3>
              </div>
              <div
                class="prose prose-indigo text-gray-500 mx-auto lg:max-w-none"
              >
                <p v-html="data.course.description"></p>
                <div>
                  <span><strong>Дата создания:</strong> </span>

                  {{ data.course.ddate }}
                </div>
              </div>
              <div
                class="mt-10 flex text-base max-w-prose mx-auto lg:max-w-none"
              >
                <div v-if="data.status_id === 0" class="rounded-md shadow mr-4">
                  <button
                    @click.prevent="startCourse"
                    class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
                    type="button"
                  >
                    Начать Курс
                  </button>
                </div>
                <div v-if="data.status_id === 1" class="rounded-md shadow mr-4">
                  <button
                    @click.prevent="breakCourse"
                    class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-red-600 hover:bg-red-700"
                    type="button"
                    title="Внимание! Весь прогресс будет утерян!"
                  >
                    Прервать прохождение Курса
                  </button>
                </div>
                <div v-if="data.canBeFinished" class="rounded-md shadow mr-4">
                  <button
                    @click.prevent="finishCourse"
                    class="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-white hover:bg-gray-50"
                    type="button"
                  >
                    Завершить Курс
                  </button>
                </div>
              </div>
            </div>
            <div
              class="mt-12 relative text-base max-w-prose mx-auto lg:mt-0 lg:max-w-none"
            >
              <svg
                class="absolute top-0 right-0 -mt-20 -mr-20 lg:top-auto lg:right-auto lg:bottom-1/2 lg:left-1/2 lg:mt-0 lg:mr-0 xl:top-0 xl:right-0 xl:-mt-20 xl:-mr-20"
                width="404"
                height="384"
                fill="none"
                viewBox="0 0 404 384"
                aria-hidden="true"
              >
                <defs>
                  <pattern
                    id="bedc54bc-7371-44a2-a2bc-dc68d819ae60"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                    patternUnits="userSpaceOnUse"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="4"
                      height="4"
                      class="text-gray-200"
                      fill="currentColor"
                    />
                  </pattern>
                </defs>
                <rect
                  width="404"
                  height="384"
                  fill="url(#bedc54bc-7371-44a2-a2bc-dc68d819ae60)"
                />
              </svg>
              <div class="relative flex flex-col bg-white rounded-lg shadow-lg">
                <img
                  :src="data.course.image"
                  alt=""
                  class="flex-shrink-0 rounded-t-lg object-cover h-48"
                />
                <div
                  class="relative flex flex-grow-1 items-center sm:items-start bg-indigo-600 rounded-b-lg not-italic py-5 px-6 sm:py-5 sm:pl-12 sm:pr-10"
                >
                  <div
                    class="relative rounded-full border-2 border-white sm:absolute sm:top-0 sm:transform sm:-translate-y-1/2"
                  >
                    <img
                      v-if="data.user.mainphoto != ''"
                      :src="data.user.mainphoto"
                      class="w-12 h-12 sm:w-20 sm:h-20 rounded-full bg-indigo-300"
                      alt=""
                    />
                    <img v-else src="/images/no_avatar.png" alt="" />
                  </div>
                  <div
                    class="relative flex flex-col ml-4 text-indigo-300 font-semibold leading-6 sm:ml-24 sm:pl-1"
                  >
                    <p class="text-white font-semibold sm:inline">Автор</p>
                    <p class="text-white font-semibold sm:inline">
                      <router-link
                        :to="{
                          name: 'user_show',
                          params: { id: data.user.id },
                        }"
                        class="underline hover:no-underline"
                        >{{ data.user.fullname }}</router-link
                      >
                    </p>

                    <p class="sm:inline">{{ data.user.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="!data.canBeFinished && data.status_id == 1"
          class="bg-white shadow sm:rounded-lg my-16 mx-4"
        >
          <div class="px-4 py-5 sm:p-6">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Следующая глава
            </h3>
            <div class="mt-5">
              <div
                class="rounded-md px-6 py-5 sm:flex sm:items-start sm:justify-between"
              >
                <div class="sm:flex sm:items-start">
                  <svg
                    class="h-8 w-auto sm:flex-shrink-0 sm:h-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                  <div class="mt-3 sm:mt-0 sm:ml-4">
                    <div class="text-sm font-medium text-gray-900">
                      <router-link
                        :to="{
                          name: 'chapter_show',
                          params: {
                            id: data.fullInfo.next_chapter.id,
                          },
                        }"
                        >{{ data.fullInfo.next_chapter.name }}</router-link
                      >
                    </div>
                    <div
                      class="mt-1 text-sm text-gray-600 sm:flex sm:items-center"
                    >
                      <div>Всего глав: {{ data.fullInfo.chapters_count }}</div>
                      <span class="hidden sm:mx-2 sm:inline" aria-hidden="true">
                        &middot;
                      </span>
                      <div class="mt-1 sm:mt-0">
                        Пройдено глав:
                        {{ data.fullInfo.chapters_finished_count }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-4 sm:mt-0 sm:ml-6 sm:flex-shrink-0">
                  <router-link
                    :to="{
                      name: 'chapter_show',
                      params: { id: data.fullInfo.next_chapter.id },
                    }"
                    class="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
                    >Продолжить прохождение</router-link
                  >
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="data.status_id > 0" class="flex flex-col mx-4">
          <h3 class="text-lg font-bold my-4">Список Глав</h3>
          <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div
              class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
            >
              <div
                class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
              >
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        ID
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Наименование
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Оценка за тестирование
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Сортировка
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="item in data.chapters" :key="item.id">
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                      >
                        {{ item.id }}
                      </td>
                      <td
                        v-if="!item.is_final || data.canRunFinalChapter"
                        class="px-6 py-4 text-sm text-gray-500"
                      >
                        <router-link
                          :to="{
                            name: 'chapter_show',
                            params: { id: item.id },
                          }"
                          class="text-gray-900"
                          >{{ item.name }}</router-link
                        >
                        <p v-html="brFunc(item.description)"></p>
                      </td>

                      <td v-else class="px-6 py-4 text-sm text-gray-900">
                        {{ item.name }}
                        <abbr
                          v-if="item.is_final"
                          title="Эта глава - финальная, будет доступна после завершения всех остальных"
                          class="rounded-full text-white px-2 py-1 bg-green-500 hover:bg-green-600 cursor-pointer"
                          >fin</abbr
                        >
                      </td>
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        <span v-if="item.grade">{{ item.grade }}</span>
                      </td>
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        {{ item.orderby }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div
        v-if="!data.canBeFinished && data.status_id == 1"
        class="card shadow p-4 m-3"
      >
        <h4 class="mb-4">Следующая глава:</h4>
        <div class="row m-0 p-0">
          <div
            class="col-12 col-md-8 p-0 d-flex justify-content-start align-items-start"
          >
            <img
              src="/icons/comp.png"
              class="pt-2"
              style="width: 32px"
              alt=""
            />
            <div class="ml-3">
              <p>
                <router-link
                  :to="{
                    name: 'chapter_show',
                    params: { id: data.fullInfo.next_chapter.id },
                  }"
                  >{{ data.fullInfo.next_chapter.name }}</router-link
                >
              </p>
              <p class="small">
                Всего глав: {{ data.fullInfo.chapters_count }} | Пройдено глав:
                {{ data.fullInfo.chapters_finished_count }}
              </p>
            </div>
          </div>
          <div
            class="col-12 col-md-4 d-flex align-items-start justify-content-md-end pr-md-5 ml-4 ml-md-0"
          >
            <router-link
              class="btn btn-success"
              :to="{
                name: 'chapter_show',
                params: { id: data.fullInfo.next_chapter.id },
              }"
              >Продолжить прохождение</router-link
            >
          </div>
        </div>
      </div> -->

      <!-- *************** -->

      <!-- <div class="my-5">
        <div class="alert alert-danger" v-if="errors.any">
          {{ errors.any }}
        </div>
        <div v-if="data.canBeFinished" class="alert alert-info" role="alert">
          Все главы пройдены! Нажмите "Завершить Курс"!
        </div>
        <div
          v-if="data.status_id == 5"
          class="alert alert-success"
          role="alert"
        >
          Этот Курс вами пройден.
        </div>
        <div v-if="data.status_id === 0" class="alert alert-info" role="alert">
          Нажмите "Начать Курс", чтобы увидеть содержимое.
        </div>
      </div>

      <div class="row my-5">
        <div class="col-12 col-md-6 text-center">
          <img :src="data.course.image" alt="" class="w-75" />

          <div class="d-flex flex-column mt-3">
            <button
              v-if="data.status_id === 0"
              type="button"
              class="btn btn-primary mb-3 mx-auto w-75"
              @click.prevent="startCourse"
              style=""
            >
              Начать Курс
            </button>
            <button
              v-if="data.status_id === 1"
              type="button"
              class="btn btn-danger mb-3 mx-auto w-75"
              @click.prevent="breakCourse"
              title="Внимание! Весь прогресс будет утерян!"
              style=""
            >
              Прервать прохождение Курса
            </button>
            <button
              v-if="data.canBeFinished"
              type="button"
              class="btn btn-success mb-3 mx-auto w-75"
              @click.prevent="finishCourse"
            >
              Завершить Курс
            </button>
          </div>
        </div>
        <div class="col-12 col-md-6 text-center text-md-left">
          <div v-if="data.status != 0" style="color: gray" class="my-3">
            Статус:
            <span v-if="data.status_id == 1" class="badge badge-info"
              >в работе</span
            >
            <span v-if="data.status_id == 5" class="badge badge-success"
              >завершён</span
            >
          </div>
          <h3>Информация о Курсе:</h3>
          <div
            class="mt-3 bg-light p-2 bg-white rounded"
            v-html="data.course.description"
          ></div>
          <div>
            <span><strong>Дата создания:</strong></span>
            &nbsp;
            {{ data.course.ddate }}
          </div>
        </div>
      </div>
      <div class="row my-5">
        <div class="col-12 col-lg-6">
          <AuthorCard v-bind:user="data.user" class="w-75 mx-auto" />
        </div>
      </div>

      <div v-if="data.status_id > 0">
        <h4>Список Глав:</h4>
        <div>
          <table class="table">
            <thead>
              <tr>
                <th>id</th>
                <th>Наименование</th>
                <th>Сортировка</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in data.chapters" :key="item.id">
                <td>{{ item.id }}</td>
                <td v-if="!item.is_final || data.canRunFinalChapter">
                  <router-link
                    :to="{ name: 'chapter_show', params: { id: item.id } }"
                    >{{ item.name }}</router-link
                  >
                  <p
                    style="font-size: 80%"
                    v-html="brFunc(item.description)"
                  ></p>
                </td>
                <td v-else>
                  {{ item.name }}
                  <abbr
                    v-if="item.is_final"
                    title="Эта глава - финальная, будет доступна после завершения всех остальных"
                    class="badge badge-info"
                    >fin</abbr
                  >
                </td>
                <td>{{ item.orderby }}</td>
                <td>
                  <span v-if="item.status == 5" class="badge badge-success">{{
                    item.statusName
                  }}</span>
                  <abbr
                    v-if="item.questions.length && item.canBeFinished"
                    class="badge badge-warning"
                    title="Перейдите к главе и нажмите 'Завершить Главу'"
                  >
                    Тестирование пройдено!
                  </abbr>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div> -->

      <!-- ******end********* -->

      <!-- Инфа о курсе и картинка: -->
      <!--
      <div class="row p-2">
        <div class="col-md-8">
          <h3>Информация о Курсе:</h3>
          <div
            class="mt-3 bg-light p-2 bg-white rounded"
            v-html="data.course.description"
          ></div>
        </div>
        <div
          class="col-md-4 text-right"
          style="
            height: 200px;
            background-size: contain;
            background-repeat: no-repeat;
          "
          :style="{ backgroundImage: 'url(' + data.course.image + ')' }"
        ></div>
      </div>
      -->

      <!-- Автор курса, дата создания и статус, кнопки начать/закончить: -->
      <!--
      <div class="row mt-2">
        <div class="col-md-6">
          <AuthorCard v-bind:user="data.user" />
        </div>
        <div class="col-md-6 text-right">
          <div class="p-4 text-right">
            <p>
              <span><strong>Дата создания:</strong></span>
              &nbsp;
              {{ data.course.ddate }}
            </p>
            <p v-if="data.status != 0" style="color: gray">
              Статус:
              <span v-if="data.status_id == 1" class="badge badge-info"
                >в работе</span
              >
              <span v-if="data.status_id == 5" class="badge badge-success"
                >завершён</span
              >
            </p>

            <p>
              <button
                v-if="data.status_id === 0"
                type="button"
                class="btn btn-block btn-primary"
                @click.prevent="startCourse"
              >
                Начать Курс
              </button>
            </p>
            <p>
              <button
                v-if="data.status_id === 1"
                type="button"
                class="btn btn-block btn-danger"
                @click.prevent="breakCourse"
                title="Внимание! Весь прогресс будет утерян!"
              >
                Прервать прохождение Курса
              </button>
            </p>
            <p>
              <button
                v-if="data.canBeFinished"
                type="button"
                class="btn btn-block btn-success"
                @click.prevent="finishCourse"
              >
                Завершить Курс
              </button>
            </p>
          </div>
        </div>
      </div>
      <div class="alert alert-danger" v-if="errors.any">
        {{ errors.any }}
      </div>
      -->

      <!--
            <p>
                <span><strong>Автор:</strong></span>
                &nbsp;
                <router-link :to="{ name: 'user_show', params: { id: data.user.id } }">{{ data.user.fullname }}</router-link>
            </p>
            <div class="card shadow p-4 m-3">
                <h3>Автор</h3>
                <div class="row d-flex">          
                    <div class="col-12 d-flex">
                        <img :src="data.user.mainphoto" style="width: 30px; float: left; border-radius: 5px;" alt="">
                        <div class="ml-3">
                            <p><router-link :to="{ name: 'user_show', params: { id: data.user.id } }">{{ data.user.fullname }}</router-link></p>
                        </div>                    
                    </div>
                    <div class="col-12 mt-3">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Odit cumque quod voluptate necessitatibus quo corporis suscipit qui dicta fuga dolor nulla aliquam praesentium, exercitationem incidunt culpa sequi. Consequatur, dicta in.
                    </div>
                </div>
            </div>  
            -->

      <!--
                Тут раньше было: дата создания курса, его статус, кнопки начать/кончить и т.п.
            <p>
                <span><strong>Дата создания:</strong></span>
                &nbsp;
                {{data.course.ddate}}
            </p>
            <div class="row">
                <div class="col">
                    <p v-if="data.status != 0" style="color:gray">
                        Статус: 
                        <span v-if="data.status_id == 1" class="badge badge-info">в работе</span>
                        <span v-if="data.status_id == 5" class="badge badge-success">завершён</span>
                    </p>    
                </div>
                <div class="text-end">
                    <button v-if="data.status_id === 0" type="button" class="btn btn-primary mr-3" @click.prevent="startCourse">Начать Курс</button>
                    <button v-if="data.status_id === 1" type="button" class="btn btn-danger mr-3" @click.prevent="breakCourse" title="Внимание! Весь прогресс будет утерян!">Прервать прохождение Курса</button>
                    <button v-if="data.canBeFinished" type="button" class="btn btn-success mr-3" @click.prevent="finishCourse">Завершить Курс</button>
                    <div class="alert alert-danger" v-if="errors.any">
                        {{ errors.any }}
                    </div>
                </div>
            </div>
            -->

      <!--
      <div class="mt-4">
        <div v-if="data.canBeFinished" class="alert alert-info" role="alert">
          Все главы пройдены! Нажмите "Завершить Курс"!
        </div>
        <div
          v-if="data.status_id == 5"
          class="alert alert-success"
          role="alert"
        >
          Этот Курс вами пройден.
        </div>
        <div v-if="data.status_id === 0" class="alert alert-info" role="alert">
          Нажмите "Начать Курс", чтобы увидеть содержимое.
        </div>
      </div>
      -->

      <!--
            <p class="font-weight-bold mt-4">Информация о Курсе:</p>
            <div class="mt-3 bg-light shadow p-3 mb-5 bg-white rounded" v-html="data.course.description"></div>
            -->

      <!--
      <div v-if="data.status_id > 0">
        <h4>Список Глав:</h4>
        <div>
          <table class="table">
            <thead>
              <tr>
                <th>id</th>
                <th>Наименование</th>
                <th>Сортировка</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in data.chapters" :key="item.id">
                <td>{{ item.id }}</td>
                <td v-if="!item.is_final || data.canRunFinalChapter">
                  <router-link
                    :to="{ name: 'chapter_show', params: { id: item.id } }"
                    >{{ item.name }}</router-link
                  >
                  <p
                    style="font-size: 80%"
                    v-html="brFunc(item.description)"
                  ></p>
                </td>
                <td v-else>
                  {{ item.name }}
                  <abbr
                    v-if="item.is_final"
                    title="Эта глава - финальная, будет доступна после завершения всех остальных"
                    class="badge badge-info"
                    >fin</abbr
                  >
                </td>
                <td>{{ item.orderby }}</td>
                <td>
                  <span v-if="item.status == 5" class="badge badge-success">{{
                    item.statusName
                  }}</span>
                  <abbr
                    v-if="item.questions.length && item.canBeFinished"
                    class="badge badge-warning"
                    title="Перейдите к главе и нажмите 'Завершить Главу'"
                  >
                    Тестирование пройдено!
                  </abbr>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      -->

      <!--
            <div>
                <br/><br/><br/><br/>
                <h3>-= ДЛЯ ОТЛАДКИ =-</h3>
                <h1>Course SHOW</h1>
                <p>course.id: {{data.course.id}}</p>
                <button :disabled="data.status_id != 0" type="button" class="btn btn-primary" @click.prevent="startCourse">Start Course</button>
                <button :disabled="data.status_id != 1" type="button" class="btn btn-danger" @click.prevent="breakCourse">BREAK Course</button>
                <button :disabled="data.status_id != 1" type="button" class="btn btn-success" @click.prevent="finishCourse">Finish Course</button>
                <button :disabled="data.status_id != 1" type="button" class="btn btn-success" @click.prevent="finishCourseFORCED">Finish Course FORCED</button>
                <div class="alert alert-danger" v-if="errors.any">
                    {{ errors.any }}
                </div>
            </div>
-->
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import PageTitle from "@/components/PageTitle";
import BreadCrumbs from "@/components/BreadCrumbs";
import ErrorMessage from "@/components/ErrorMessage";

// import AuthorCard from "@/components/AuthorCard";
import moment from "moment";
//import jQuery from 'jquery'
export default {
  components: {
    Loader,
    ErrorMessage,
    PageTitle,
    BreadCrumbs,
    // AuthorCard,
  },
  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "", any: "" },
      title: "",
      bcrumbs: [],
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {
    //
    // Переносы из textarea конвертим в переносы для абзаца.
    //
    brFunc(str) {
      if (str) {
        return str.replace(/\n/g, "<br />");
      }
    },
    async loadData() {
      //console.log(this.$route.params.id);
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get("courses/" + this.$route.params.id);
        this.data = response.data;
        // cookieme
        // console.log(this.data);
        // this.data.status_id = 1;
        // this.data.canBeFinished = true;
        // cookiemeend
        this.title = this.data.course.name;
        this.data.course.ddate = moment(this.data.course.created_at).format(
          "DD.MM.YYYY"
        );
        this.bcrumbs = response.data.bcrumbs;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },
    async startCourse() {
      this.errors.any = "";
      try {
        let response = await axios.post(
          "courses/" + this.$route.params.id + "/start"
        );
        if (response.status == 200) {
          this.loading = true;
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Неизвестная ошибка при старте Курса.";
        }
      }
    },
    async breakCourse() {
      this.errors.any = "";
      try {
        let response = await axios.post(
          "courses/" + this.$route.params.id + "/break"
        );
        if (response.status == 200) {
          this.loading = true;
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Неизвестная ошибка при прерывании Курса.";
        }
      }
    },
    async finishCourse() {
      this.errors.any = "";
      try {
        let response = await axios.post(
          "courses/" + this.$route.params.id + "/finish"
        );
        if (response.status == 200) {
          this.loading = true;
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Неизвестная ошибка при завершении Курса.";
        }
      }
    },
    async finishCourseFORCED() {
      this.errors.any = "";
      try {
        let response = await axios.post(
          "courses/" + this.$route.params.id + "/finishFORCED"
        );
        if (response.status == 200) {
          this.loading = true;
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 520) {
          this.errors.any = e.response.data.error;
        } else {
          this.errors.any = "Неизвестная ошибка при завершении Курса.";
        }
      }
    },
  },
};
</script>


<style scoped>
</style>